import useAppStore from "@/store/use-app-store";
import useJobStore from "@/store/use-job-store";
import {
  consoleBeauty,
  getFirstInArray,
  isIdentical,
  isObjectEmpty,
  saveParseJson,
  saveStringify,
  validArray,
} from "data/functions";
import { parse } from "graphql";
// import { getEventTypeMap } from "./queris/get-event";

// export function createHandleQueryDataJob(gqlQuery) {
//   return function handleQueryDataJob(data) {
//     const fieldName = getGraphQLFieldName(gqlQuery);
//     if (!fieldName) return;

//     const result = data?.[fieldName];
//     const map = getEventTypeMap();
//     const methodType = map[fieldName];

//     if (
//       methodType &&
//       !isObjectEmpty(result) &&
//       !isObjectEmpty(result?.eventUuid)
//     ) {
//       useJobStore.getState()?.pushJobList({
//         state: "CREATED",
//         type: methodType,
//         uuid: result.eventUuid,
//       });
//     }
//   };
// }

export function getGraphQLFieldName(documentNode) {
  try {
    const ast = documentNode?.loc?.source?.body;
    if (!ast) return;

    const parsed = parse(ast);
    const operation = parsed.definitions.find(
      (defer) => defer.kind === "OperationDefinition",
    );

    if (!operation || operation.operation !== "query") return;

    const field = operation.selectionSet.selections[0];
    return field?.name?.value || "";
  } catch (error) {
    console.error("Failed to parse GraphQL query:", error);
    return;
  }
}

export function handleQueryError(error, queryName = "Unknown") {
  logGQLError(queryName, error);
}

export function logGQLError(queryName, error) {
  try {
    let text =
      getFirstInArray(error?.networkError?.result?.errors)?.message ||
      error.message;

    sessionStorage.setItem(
      "error_" + new Date(Date.now()).toISOString(),
      queryName + ": " + text,
    );

    consoleBeauty(queryName + ": " + text, "GraphQL", "red");
  } catch {}
}

export async function getCompanyStyle(getCompanyExtensionDataQuery) {
  const companyUuid = useAppStore.getState().companyUuid;
  if (!companyUuid) return;
  let { data } = await getCompanyExtensionDataQuery({
    variables: {
      companyUuid,
    },
  });

  if (data && !isObjectEmpty(data?.acc_getCompanyExtData)) {
    let extensionData = data?.acc_getCompanyExtData;
    let style = extensionData?.styleUrls;

    useAppStore.setState((state) => ({
      ...(isIdentical(state?.companyName, extensionData?.name)
        ? {}
        : { companyName: extensionData?.name }),

      ...(isIdentical(state?.companyTitle, extensionData?.title)
        ? {}
        : { companyTitle: extensionData?.title }),

      ...(isIdentical(state?.companyStyle, style)
        ? {}
        : { companyStyle: style }),
    }));

    return;
  }
}

export async function getMessageBySignUuid(getMessageQuery) {
  let message = useAppStore.getState().message || {};
  if (!message?.sign_data_uuid) return;

  let { data } = await getMessageQuery({
    variables: {
      dataUuid: message?.sign_data_uuid,
    },
  });

  if (data && !isObjectEmpty(data?.mrkcd_GetSignData)) {
    let res = data?.mrkcd_GetSignData;

    if (message.sign_data_uuid !== res?.uuid) return;

    message.text = res.data;
    message.sign_data_uuid = "";

    if ((!isIdentical(useAppStore.getState()?.message), message)) {
      useAppStore.setState({
        message: {
          ...message,
        },
      });
    }

    return;
  }
}

export async function putCacheFunction(
  key,
  value,
  putCacheMutation,
  workspace = "5s_tsd",
) {
  const token = useAppStore.getState()?.token;
  let stringValue = saveStringify(value);
  if (!token || !key || !stringValue) {
    return;
  }
  putCacheMutation({
    variables: {
      input: {
        key: key,
        value: stringValue,
        workspace: workspace,
      },
    },
  });
}

export async function getCache(options = {}) {
  const { refetchCacheQuery, setCacheInit } = options;
  try {
    const { data, error } = await refetchCacheQuery({
      variables: {
        workspace: "5s_tsd",
      },
    });

    if (data) {
      const cacheItems = validArray(
        data?.acc_getCache,
        "TAuthProvider.getCache",
      );

      for (const item of cacheItems) {
        const value = saveParseJson(item.value);
        if (!isIdentical(useAppStore.getState()?.[item.key], value)) {
          useAppStore.setState({ [item.key]: value });
        }
        useAppStore.setState((state) => ({
          ["cache_" + item.key]: value,
        }));
      }
    }
    if (data || error) {
      setCacheInit(true);
    }
  } catch {}
}
